export default __webpack_public_path__ + "static/media/milkyway.f163dead.jpg";